import React from 'react';

const EVENT_LABELS = {
    SUCCESS_SENDING_MAIL: 'Campaña enviada',
    ERROR_SENDING_MAIL: 'Error de envío',
    SEEN: 'Campaña abierta',
    CLICK_ON_LINK: 'Clic en campaña',
    UNSUSCRIBE: 'Baja de suscripción'
};

const EVENT_COLORS = {
    SUCCESS_SENDING_MAIL: '#28a745',
    ERROR_SENDING_MAIL: '#dc3545',
    SEEN: '#17a2b8',
    CLICK_ON_LINK: '#fd7e14',
    UNSUSCRIBE: '#6c757d'
};

const ENGAGEMENT_LABELS = {
    none: 'Sin actividad',
    sent_only: 'Solo envíos',
    active: 'Activo',
    unsubscribed: 'Desuscrito',
    unknown: 'Sin clasificar'
};

const ENGAGEMENT_BADGE = {
    none: 'secondary',
    sent_only: 'info',
    active: 'success',
    unsubscribed: 'danger',
    unknown: 'warning'
};

function formatDate(dateStr) {
    if (!dateStr) return '—';
    try {
        const d = new Date(dateStr);
        return d.toLocaleString('es-CL', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (e) {
        return dateStr;
    }
}

function SummaryCards({ summary }) {
    const cards = [
        { label: 'Campañas recibidas', value: summary.sent ?? 0 },
        { label: 'Aperturas', value: summary.opens ?? 0 },
        { label: 'Clics', value: summary.clicks ?? 0 },
        { label: 'Errores', value: summary.errors ?? 0 },
        { label: 'Última interacción', value: formatDate(summary.last_touch_at) },
        {
            label: 'Estado engagement',
            value: (
                <span className={`badge badge-${ENGAGEMENT_BADGE[summary.engagement_status] || 'secondary'}`}>
                    {ENGAGEMENT_LABELS[summary.engagement_status] || 'Sin clasificar'}
                </span>
            )
        }
    ];

    return (
        <div className="row mb-4">
            {cards.map((card, i) => (
                <div key={i} className="col-6 col-md-4 col-lg-2 mb-3">
                    <div className="card h-100 text-center shadow-sm" style={{ border: '1px solid #e9ecef', borderRadius: 8 }}>
                        <div className="card-body p-3">
                            <div style={{ fontSize: 22, fontWeight: 700, color: '#2c3e50' }}>{card.value}</div>
                            <div style={{ fontSize: 11, color: '#6c757d', marginTop: 4 }}>{card.label}</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

function TimelineItem({ event }) {
    const label = event.label || EVENT_LABELS[event.type] || event.type;
    const color = EVENT_COLORS[event.type] || '#6c757d';
    const campaignName = event.campaign_name || 'Campaña sin nombre';

    return (
        <div className="d-flex mb-3" style={{ gap: 12 }}>
            <div style={{ flexShrink: 0, paddingTop: 2 }}>
                <div style={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    background: color,
                    marginTop: 4,
                    border: `2px solid ${color}`
                }} />
            </div>
            <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#2c3e50' }}>{label}</div>
                <div style={{ fontSize: 13, color: '#555', marginTop: 2 }}>{campaignName}</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>
                    {formatDate(event.created_at)}
                    {event.channel && <span style={{ marginLeft: 8 }}>· {event.channel === 'email' ? 'Email' : event.channel}</span>}
                </div>
            </div>
        </div>
    );
}

export function InteractionHistory({ summary, events, loading, error, emptyMessage }) {
    return (
        <div>
            <h6 style={{ fontWeight: 700, color: '#2c3e50', marginBottom: 16 }}>Historial de interacciones</h6>

            {loading && (
                <div className="text-center py-4">
                    <div className="spinner-border spinner-border-sm text-secondary" role="status" />
                    <span className="ml-2 text-muted" style={{ fontSize: 13 }}>Cargando historial...</span>
                </div>
            )}

            {!loading && error && (
                <div className="alert alert-warning" style={{ fontSize: 13 }}>
                    No fue posible cargar el historial de interacciones.
                </div>
            )}

            {!loading && !error && summary && (
                <SummaryCards summary={summary} />
            )}

            {!loading && !error && events && events.length === 0 && (
                <div className="card" style={{ border: '1px solid #e9ecef', borderRadius: 8 }}>
                    <div className="card-body text-center py-5" style={{ color: '#6c757d', fontSize: 14 }}>
                        {emptyMessage || 'Sin interacciones registradas.'}
                    </div>
                </div>
            )}

            {!loading && !error && events && events.length > 0 && (
                <div className="card" style={{ border: '1px solid #e9ecef', borderRadius: 8 }}>
                    <div className="card-body" style={{ padding: '20px 24px' }}>
                        <div style={{ borderLeft: '2px solid #e9ecef', paddingLeft: 16 }}>
                            {events.map((event) => (
                                <TimelineItem key={event.id} event={event} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
